import { render } from "./HotelAnnexes.vue?vue&type=template&id=30e35a23&scoped=true"
import script from "./HotelAnnexes.vue?vue&type=script&lang=js"
export * from "./HotelAnnexes.vue?vue&type=script&lang=js"

import "./HotelAnnexes.vue?vue&type=style&index=0&id=30e35a23&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e35a23"]])

export default __exports__